import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useTTS } from "../../../../../hooks/useTTS";

import VocaMatchingPage from "../../analysis/vocabulary/VocaMatchingPage";
import VocaStudyPage from "../../analysis/vocabulary/VocaStudyPage";
import CommonPage from "../../common/CommonPage";

const MatchingPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const currentPage = pageList[currentIndex] || { type: "", data: {} };

  useEffect(() => {
    if (pageList.length > 0) {
      return;
    }
    const tempPageList = [];
    const words = section.question.words.map((element) => {
      return {
        eng: element.word,
        kor: element.kor.split("\n")[0].replace(/\[.*?\]\s*/g, ""),
      };
    });

    for (let i = 0; i < Math.ceil(words.length / 10); i++) {
      tempPageList.push({
        type: "study",
        data: words.slice(i * 10, (i + 1) * 10).map((word) => {
          return { ...word, isOpened: false };
        }),
      });
    }
    for (let i = 0; i < Math.ceil(words.length / 5); i++) {
      tempPageList.push({
        type: "matching",
        data: words.slice(i * 5, (i + 1) * 5).map((word) => {
          return { ...word, isMatched: false };
        }),
      });
    }
    setPageList(tempPageList);
    setCurrentIndex(0);
  }, [section]);

  const handleNextPage = () => {
    if (currentIndex + 1 < pageList.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      alert("매칭게임 학습 완료했습니다.");
      setCurrentStep(2);
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <CommonPage
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      currentPage={currentPage}
      currentIndex={currentIndex}
      totalNo={pageList.length}
    >
      {currentPage.type === "matching" && (
        <VocaMatchingPage
          currentPage={currentPage}
          section={section}
          pageList={pageList}
          setPageList={setPageList}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          isReview={isReview}
          type={"vocabulary"}
        />
      )}
      {currentPage.type === "study" && (
        <VocaStudyPage
          currentPage={currentPage}
          section={section}
          pageList={pageList}
          setPageList={setPageList}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          isReview={isReview}
          type={"vocabulary"}
        />
      )}
    </CommonPage>
  );
};

export default MatchingPage;
